<!--资环行动-详情页-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="act" :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class="box-width newsDetail">
        <h4>{{ videoDetail.title }}</h4>
        <span class="time">{{ videoDetail.releaseTime }}</span>
        <video
          controls
          autoplay
          muted
          :src="videoDetail.fullPathUrl != null ? videoDetail.fullPathUrl : ''"
          style="width: 100%; height: auto;"></video>
      </div>
      <!--内容-->
      <div v-html="replaceContent(videoDetail.content)" class="htmlImgSize box-width"></div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <div class="box-width mobileDetail">
          <h4 >{{ videoDetail.title }}</h4>
          <span class="time">{{ videoDetail.releaseTime }}</span>
          <video
            controls
            autoplay
            muted
            :src="videoDetail.fullPathUrl != null ? videoDetail.fullPathUrl : ''"
            style="width: 100%; height: auto;"></video>
        </div>
        <!--内容-->
        <div v-html="replaceContent(videoDetail.content)" class="htmlImgSize"></div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findVideoOne } from '@/api/zh'

export default {
  data () {
    return {
      components: {
        tail: header,
        tail1: footer
      },
      videoDetail: {},
      videoId: null
    }
  },
  created () {
    this.videoId = this.$route.query.videoId
  },
  mounted () {
    this.getVideoDetail()
  },
  methods: {
    async getVideoDetail () {
      const res = await findVideoOne(this.videoId)
      if (res.code === 200) {
        this.videoDetail = res.data
      }
    },
    replaceContent (content) {
      return content.replace(/http:\/\/8\.155\.44\.137:9000\/zihuan\//g, 'https://gdlsfw.com/zihuan/');
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
  background: transparent;
}
</style>
